import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link, Outlet } from 'react-router-dom'
import type { Permission } from './permissions'
import { usePermissions } from './usePermissions'

interface RequirePermissionProps {
  /** Kamida bittasi bo'lsa sahifa ochiladi */
  permission: Permission | readonly Permission[]
}

/**
 * Marshrut darajasidagi huquq qo'riqchisi.
 *
 * Navigatsiya baribir ko'rinmaydigan sahifaga havola chizmaydi, lekin URL
 * qo'lda kiritilishi yoki eski havola saqlangan bo'lishi mumkin. U holda
 * "Ruxsat yo'q" ko'rsatiladi — bo'sh sahifa yoki tushunarsiz xato emas.
 *
 * ⚠️ Yana bir bor: bu QULAYLIK. Ma'lumot baribir backend tekshiruvidan
 * o'tmasdan kelmaydi (04-ROLES.md §8).
 */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const { t } = useTranslation()
  const { canAny } = usePermissions()
  // `Array.isArray` `readonly` massivni `any[]` ga toraytiradi — `Can.tsx` dagi izohga qarang
  const list: readonly Permission[] = typeof permission === 'string' ? [permission] : permission

  if (!canAny(...list)) {
    return (
      <Result
        status="403"
        title={t('access.deniedTitle')}
        subTitle={t('access.deniedText')}
        extra={
          <Link to="/">
            <Button type="primary">{t('access.backToStart')}</Button>
          </Link>
        }
      />
    )
  }

  return <Outlet />
}
